import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chat-typing-indicator',
  standalone: true,
  imports: [],
  templateUrl: './chat-typing-indicator.component.html',
  styleUrls: ['./chat-typing-indicator.component.scss']
})
export class ChatTypingIndicatorComponent {
  @Input() label = 'Billie está pensando…';
}
